export default "__VITE_ASSET__CiZUr_kL__"